module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAMAAADK8RQqAAAAAXNSR0IB2cksfwAAADxQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0C8mMAAAABR0Uk5TABv7/8MpB7QOFcIo/sQxGufjFyaum01lAAAAWUlEQVR4nI2QUQ6AMAhDqzB1KtPp/e8q6pd2izZAwgspBKBphaQBXT+AFEdAGF/QY5pFLDHXxYsx900vv7s3lOeTlf1r99T4KvmR3/On8j9/i4w3BYIW/rwf8bMCtcavDwgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/billing-icon.png
// module id = 721
// module chunks = 0